function upsertMeta({ selector, attr, value }) {
  if (!selector || !attr || value === undefined || value === null) return;

  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    const [attributeName, attributeValue] = attr.split("=");
    if (attributeName && attributeValue) {
      element.setAttribute(attributeName, attributeValue);
    }
    document.head.appendChild(element);
  }

  element.setAttribute("content", String(value));
}

export function applyDocumentMetadata({
  title,
  description,
  image,
  siteName,
  url,
}) {
  if (title) {
    document.title = String(title);
  }

  if (description) {
    upsertMeta({ selector: 'meta[name="description"]', attr: "name=description", value: description });
  }

  upsertMeta({ selector: 'meta[property="og:type"]', attr: "property=og:type", value: "website" });

  if (title) {
    upsertMeta({ selector: 'meta[property="og:title"]', attr: "property=og:title", value: title });
    upsertMeta({ selector: 'meta[name="twitter:title"]', attr: "name=twitter:title", value: title });
  }

  if (description) {
    upsertMeta({ selector: 'meta[property="og:description"]', attr: "property=og:description", value: description });
    upsertMeta({ selector: 'meta[name="twitter:description"]', attr: "name=twitter:description", value: description });
  }

  if (image) {
    upsertMeta({ selector: 'meta[property="og:image"]', attr: "property=og:image", value: image });
    upsertMeta({ selector: 'meta[name="twitter:image"]', attr: "name=twitter:image", value: image });
  }

  if (siteName) {
    upsertMeta({ selector: 'meta[property="og:site_name"]', attr: "property=og:site_name", value: siteName });
  }

  if (url) {
    upsertMeta({ selector: 'meta[property="og:url"]', attr: "property=og:url", value: url });
  }

  upsertMeta({ selector: 'meta[name="twitter:card"]', attr: "name=twitter:card", value: "summary_large_image" });
}
